'use client';

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
import { useState } from 'react';
interface Props {
  children: React.ReactNode;
  className?: string;
  /** The lines the text wraps to before it ends in "…". */
  lines?: 1 | 2;
  title?: React.ReactNode;
}
export const TruncatedText = t0 => {
  const $ = _c(18);
  const {
    children,
    className,
    lines: t1,
    title
  } = t0;
  const lines = t1 === undefined ? 1 : t1;
  const [isOverflowing, setIsOverflowing] = useState(false);
  let t2;
  if ($[0] !== lines) {
    t2 = node => {
      if (!node) {
        return;
      }
      const syncOverflow = () => setIsOverflowing(lines === 1 ? node.scrollWidth > node.clientWidth : node.scrollHeight > node.clientHeight);
      const observer = new ResizeObserver(syncOverflow);
      observer.observe(node);
      return () => observer.disconnect();
    };
    $[0] = lines;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const measureRef = t2;
  const t3 = lines === 1 ? "block truncate" : "line-clamp-2 wrap-break-word";
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = cn("min-w-0 leading-5", t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== measureRef || $[6] !== t4) {
    t5 = <span className={t4} ref={measureRef} />;
    $[5] = measureRef;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== t5) {
    t6 = <TooltipTrigger render={t5} data-sentry-element="TooltipTrigger" data-sentry-source-file="truncated-text.tsx">{children}</TooltipTrigger>;
    $[8] = children;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== isOverflowing || $[13] !== title) {
    t7 = isOverflowing || title != null ? <TooltipContent className="max-w-xs wrap-break-word whitespace-pre-wrap">{title ?? children}</TooltipContent> : null;
    $[11] = children;
    $[12] = isOverflowing;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Tooltip data-sentry-element="Tooltip" data-sentry-component="TruncatedText" data-sentry-source-file="truncated-text.tsx">{t6}{t7}</Tooltip>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};